import { render } from "./App.vue?vue&type=template&id=70a95790"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=70a95790&lang=css"

import exportComponent from "/home/vv-finance/.jenkins/workspace/pro-pinsen-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__